<template>
  <div class="w-full">
    <div class="mt-10 flex flex-wrap justify-center gap-6" :style="cssVars">
      <a
          v-for="(download, index) in attachments"
          :key="index"
          v-motion
          :initial="{ opacity: 0, y: 30 }"
          :visible="{ opacity: 1, y: 0 }"
          :transition="{ duration: 1.5, ease: 'easeOut' }"
          class="block max-w-md hover:cursor-pointer hover:animate-pulse"
          :href="download.url"
          target="_blank"
          rel="noopener"
      >
        <component :is="cardComponent" :colors="colors" :variant="index % 2 === 0 ? 1 : 2" class="p-6 h-full text-center">
        <div class="h-full rounded flex flex-col items-center justify-start gap-4" >
          <div class="mt-4 font-bold w-full flex items-center justify-center" style="color: var(--theme-text-heading);">
            <CloudDownload class="inline-block w-6 h-6 mr-2" :style="{color: colors.accent}" />
          </div>
          <p class="text-sm" style="color: var(--theme-text-muted);">
            {{ download.label }}
          </p>
        </div>
        </component>
      </a>
    </div>
  </div>

</template>
<script setup>
import {CloudDownload} from "@iconoir/vue"
import {computed} from "vue";
import {useThemedComponent} from "@/composables/useThemedComponent.js";
const props = defineProps({
  attachments: Array,
  backgroundVariant: {type: Number, default: 1}, // Alternates background
  colors: {type: Object, required: true} // Use colors from the schema
});

const cardComponent = useThemedComponent("card");

// Compute CSS variables for dynamic background and card colors
const cssVars = computed(() => ({
  "--bg-light-variant-1": "#ffffff",
  "--bg-light-variant-2": props.colors.lightest,
  "--bg-dark-variant-1": props.colors.dark,
  "--bg-dark-variant-2": props.colors.darkest,
  "--card-light": props.colors.white,
  "--card-light-alt": props.colors.whitest,
  "--card-dark": props.colors.dark,
  "--card-dark-alt": props.colors.darkest,
  "--border-color-light": props.colors.accent,
  "--border-color-dark": props.colors.accentDark
}));

// Dynamically set background class using Tailwind dark mode
const computedBackgroundClass = computed(() =>
    props.backgroundVariant === 1
        ? "bg-[var(--bg-light-variant-1)] dark2:bg-[var(--bg-dark-variant-1)]"
        : "bg-[var(--bg-light-variant-2)] dark2:bg-[var(--bg-dark-variant-2)]"
);


</script>

<style scoped>
/* Smooth background transitions */
.transition-colors {
  transition: background-color 0.3s ease-in-out;
}
</style>
